// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Description-module--cls1--3wweC","cls2":"styles-Description-module--cls2--aIgah styles-Description-module--cls1--3wweC"};